import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe } from '@angular/core';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe {
  constructor(private sanitizer: DomSanitizer) {}

  transform(style: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(style);
    // return this.sanitizer.bypassSecurityTrustStyle(style);
    // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
  }
}
